import React, { InputHTMLAttributes } from 'react';
import styled, { css } from 'styled-components';

const thumb = css`
  width: 28px;
  height: 28px;
  background: var(--c-white);
  border-radius: var(--double-unit);
  box-shadow: 0px 4px 4px 0px #00000029;
`;

const track = css`
  background: var(--track-bg);
  width: 100%;
  height: var(--unit);
  border-radius: var(--unit);
`;

const StyledInput = styled.input`
  --track-bg: var(--c-white);
  width: 100%;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-appearance: none;
  &::-moz-range-thumb {
    ${thumb}
  }
  &::-webkit-slider-thumb {
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-appearance: none;
    ${thumb}
    margin-top: -10px;
  }
  &::-moz-range-track {
    ${track}
  }
  &::-webkit-slider-runnable-track {
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-appearance: none;
    ${track}
  }
`;

type Props = Pick<
  InputHTMLAttributes<HTMLInputElement>,
  'value' | 'min' | 'max' | 'step' | 'onChange'
> & {
  onRelease: () => void;
};

export const RangeInput = ({ onRelease, ...otherProps }: Props) => {
  return (
    <StyledInput
      type="range"
      {...otherProps}
      onTouchEnd={onRelease}
      onMouseOut={onRelease}
      onMouseUp={onRelease}
    />
  );
};
